import { Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AcceptSignupInvitationRequest } from '../../../swagger-api';
import { AcceptSignupInvitationAbstract } from '../accept-signup-invitation.abstract';

@Component({
  selector: 'app-accept-admin-signup-invitation',
  templateUrl: '../accept-signup-invitation.component.html',
  styleUrls: ['../accept-signup-invitation.component.scss'],
})
export class AcceptAdminSignupInvitationComponent extends AcceptSignupInvitationAbstract {
  private translateService = inject(TranslateService);

  protected acceptUserSignupInvitation(registerIndividualUser: AcceptSignupInvitationRequest): void {
    this.authService.signupByInvitation(registerIndividualUser);
  }

  public get getFormTitle(): string {
    return this.translateService.instant('ACCEPT_ADMIN_SIGNUP_INVITATION_FORM_TITLE') as string;
  }
}
